import {getAddressName, getLocationName, convertSize, getStatusLabel} from "@/services/tableDataFormater";
import i18n from "@/boot/i18n";
import {iEmptyData} from "@/filter/iEmptyData";

export function iCapitalizeString(str) {
  try {
    return str[0].toUpperCase() + str.slice(1).toLowerCase()
  } catch (e) {
    return str
  }
}

const dateFormatter = new Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale);
const locale = Intl.DateTimeFormat().resolvedOptions().locale;

function prefersHour12(locale) {
  const options = new Intl.DateTimeFormat(locale, {hour: 'numeric'}).resolvedOptions();
  return options.hour12;
}

const useHour12 = prefersHour12(locale);
const dateTimeFormatter = new Intl.DateTimeFormat(locale, {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  hour12: useHour12,
});

export function formatDateTime(dateTimeString) {
  try {
    if (dateTimeString) return dateTimeFormatter.format(new Date(dateTimeString));
    return i18n.global.t('common.na');
  } catch (e) {
    return dateTimeString;
  }
}

export function formatDateTimeNoComma(dateTimeString) {
  try {
    if (!dateTimeString) return "/";
    const formatted = dateTimeFormatter.format(new Date(dateTimeString));
    return formatted.replace(/,\s*/, " ");
  } catch (e) {
    return dateTimeString;
  }
}

export function formatDate(dateTimeString) {
  try {
    if (dateTimeString) return dateFormatter.format(new Date(dateTimeString));
  } catch (e) {
    return dateTimeString;
  }
}

export function iFormatAddress(address) {
  try {
    if (address) return getAddressName(address);
  } catch (e) {
    return address;
  }
}

export function iFormatLocation(location, providerTenant) {
  try {
    if (location) {
      if (providerTenant === 'MICROSOFT') return getLocationName(location);
      else return location.replace(/"/g, '');
    }
  } catch (e) {
    return location;
  }
}

export function iConvertSize(size) {
  try {
    if (size) return convertSize(size);
  } catch (e) {
    return size;
  }
}

export function iConvertItemsSize(size) {
  try {
    if (size) return convertSize(size);
    return '0';
  } catch (e) {
    return size;
  }
}

export function iGetStatusLabel(value) {
  try {
    if (value) return getStatusLabel(value);
  } catch (e) {
    return value;
  }
}

export default function registerFilters(app) {
  app.config.globalProperties.$filters = {
    formatDateTime,
    formatDateTimeNoComma,
    formatDate,
    iFormatAddress,
    iFormatLocation,
    iConvertSize,
    iConvertItemsSize,
    iGetStatusLabel,
    iEmptyData,
    iCapitalizeString,
  };
}